"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorOptimizeQueryOperationBgpToJoin = void 0;
const bus_optimize_query_operation_1 = require("@comunica/bus-optimize-query-operation");
const context_entries_1 = require("@comunica/context-entries");
const core_1 = require("@comunica/core");
const utils_algebra_1 = require("@comunica/utils-algebra");
/**
 * A comunica BGP to Join Optimize Query Operation Actor.
 */
class ActorOptimizeQueryOperationBgpToJoin extends bus_optimize_query_operation_1.ActorOptimizeQueryOperation {
    async test(_action) {
        return (0, core_1.passTestVoid)();
    }
    async run(action) {
        const dataFactory = action.context.getSafe(context_entries_1.KeysInitQuery.dataFactory);
        const algebraFactory = new utils_algebra_1.AlgebraFactory(dataFactory);
        const operation = utils_algebra_1.algebraUtils.mapOperation(action.operation, {
            [utils_algebra_1.Algebra.Types.BGP]: {
                preVisitor: () => ({ continue: false }),
                transform: bgpOp => algebraFactory.createJoin(bgpOp.patterns),
            },
        });
        return { operation, context: action.context };
    }
}
exports.ActorOptimizeQueryOperationBgpToJoin = ActorOptimizeQueryOperationBgpToJoin;
//# sourceMappingURL=ActorOptimizeQueryOperationBgpToJoin.js.map